import script from "./FormStringListField.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormStringListField.vue?vue&type=script&lang=ts&setup=true"

import "./FormStringListField.vue?vue&type=style&index=0&id=4737a869&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4737a869"]])

export default __exports__